<template>
    <Header />
    <MenuBar v-model="activeTab"/>

    <!-- <AppointmentTabs v-model="activeTab" /> -->

    <div class="edit_application d-flex flex-column min-vh-100">

      <div class="container tabs-containe pb-5">
          <div class="row d-flex align-items-stretch">
              <div class="col-md-12 mt-lg-5 mt-3 h-100 content d-flex flex-column h-100">

                <div class="tab-content" id="myTabContent">
                  <AppointmentDetails v-if="activeTab === 'upcoming'" class="tab-pane fade show active" />
                  <AppointmentHist v-else  class="tab-pane fade show active"/>
                </div>
                
              
              </div>
          </div>
      </div>

    </div>
   

    <Footer />
</template>
<script>
import Footer from '@/components/Appointment/Layouts/Footer.vue';
import Header from '@/components/Appointment/Layouts/NewHeader.vue';
import MenuBar from '@/components/Appointment/Layouts/MenuBar.vue';
import AppointmentDetails from '@/components/Appointment/Sections/Details/AppointmentDetails.vue';
import AppointmentHist from '@/components/Appointment/Sections/History/AppointmentHist.vue';
import { useUserStore } from '@/store/user'
export default {
  name: 'trackDetailsView',
  components: {
    Footer,
    Header,
    MenuBar,
    AppointmentDetails,
    AppointmentHist,
  },
  
  data() {
    return {
      activeTab: 'upcoming',
    };
  },
  mounted() {
      const userStore = useUserStore();
      const token = localStorage.getItem('authToken') || userStore.authToken;
      //console.log("token:", token);
      if (!token) {
        this.$router.push({ name: 'trackAppointment' });
        return;
      }
      ///console.log("no token:"); 
  },
  
};
</script>
